import styled from 'styled-components';
import Typography from '../../theme/typography';
import StyledIcon from '../../atoms/Icon/styles';
import {
  StyledProps,
  StyledBodyProps,
  StyledHeaderProps,
  StyledAccordionTitleProps,
} from './typings';
import colors from '../../theme/constants/colors';
import {sizePx} from '@/theme/helpers/size';
import focus from '@/theme/focus';

const StyledAccordion = styled.section<StyledProps>`
  padding: 0;
  overflow: visible;
  ${(props) =>
    props.$hasDividers &&
    `
  border-top: 1px solid ${colors.grey50};
  border-bottom: 1px solid ${colors.grey50};

  ${StyledAccordion} + ${StyledAccordion}{
    border-top: none;
  }
`}
`;

export const StyledAccordionTitle = styled.h4<StyledAccordionTitleProps>`
  ${(props) => (props.$strongTitle === true ? Typography.Subtitle1 : Typography.Body1)}
  grid-area: title;
`;

export const StyledAccordionSubtitle = styled.p`
  ${Typography.Body3}
  grid-area: subtitle;
`;

export const StyledAccordionHeader = styled.div<StyledHeaderProps>`
  display: grid;
  grid-template-columns: 1fr ${sizePx(8)};
  grid-template-areas: 'title icon' 'subtitle .';
  padding: ${sizePx(8)} 0;
  ${(props) => props.$collapsible && 'cursor: pointer;'}

  ${focus.brand()}

  ${StyledIcon}.icon-minus, 
  ${StyledIcon}.icon-plus {
    grid-area: icon;
    align-self: center;
  }
`;

export const StyledAccordionBody = styled.div<StyledBodyProps>`
  display: ${(props) => (props.$open === true ? 'block' : 'none')};
  padding: ${sizePx(4)} 0 ${sizePx(10)};
  overflow-x: hidden;
`;

export default StyledAccordion;
